export default "<p>Loading...</p>\r\n"